
import {MdOutlineMoreHoriz} from "react-icons/md"

import styled from "styled-components"
import formatConverter from "../../../../helper/formatConverter"
import { formatShipmentDate, getShipmentRouteBounds, normalizeShipmentListItem } from "../../../../helper/shipment/safeShipmentListItem"
import { useState, useEffect} from "react"
import { useDispatch } from "react-redux"
import moment from "moment"
import { showModal, showNestedModal } from "../../../../features/modal/modalSlice"
import { setSelectUserData } from "../../../../features/user/userSlice"
import { getBelgeData, setTopPagesItemNotificationClicked } from "../../../../features/loadList/loadListSlice"
import { useSelector } from "react-redux"
import CopyableShipmentValue from "../../../shipmentOperation/CopyableShipmentValue"
import { compactShipmentCardStyles } from "../../../shipmentOperation/shipmentCardStyles"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
    color: ${({theme}) => theme.mainTextColor};
    cursor: pointer;

    .titles-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
        padding-left: 40px;
        padding-right: 20px;

        .title-item{
            width: 15%;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);

            &:last-child{
                width: 100px;
            }
        }
    }

    .content-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        background-color: ${({theme, isNotificationed}) => isNotificationed ? "#e854461d" :theme.secondaryBgColor};
        ${({ border }) => border && `animation: blinkBorder 3s step-end 3`};
        border-radius: 10px;
        padding-left: 40px;
        padding-right: 20px;
        border: 2px solid transparent;
        position: relative;
    padding-bottom: 20px;

            .absolute-id{
            position: absolute;
            bottom: 0;
            left: 0;
            border: 1px solid var(--color-main);
            border-radius: 4px;
            border-bottom-left-radius: 10px;
            padding: 3px;
            font-size: 14px;
            width: 70px;
            text-align: center;
            font-weight: var(--font-weight-lg);
            background-color: var(--color-main);
            color:#fff;
        }
        .comment{
            cursor: pointer;
        }

        .action-menu-column{
            position: relative;
        }

        .more-button{
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 4px;
            border: 0;
            background: transparent;
            color: inherit;
            cursor: pointer;

            .more-icon{
                font-size: 1.5rem;
            }
        }

        .actions-popover{
            position: absolute;
            top: 34px;
            right: 0;
            z-index: 5;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 8px;
            min-width: 175px;
            padding: 10px;
            border: 1px solid ${({theme}) => theme.mainBorderColor};
            border-radius: 8px;
            background: ${({theme}) => theme.secondaryBgColor};
            box-shadow: 0 8px 20px rgba(20, 24, 32, 0.14);
        }
        .content-column{
            width: 15%;
            display: flex;
            flex-direction: column;
            gap: 5px;
            padding: 15px 0;

            .content-item{
                font-weight: var(--font-weight-md);
                font-size: var(--font-size-sm);

                .more-icon{
                    font-size: 1.5rem;
                }
            }

            .underline{
                text-decoration: underline;
                cursor: pointer;
            }

            .btn-outlined{
                border: 1px solid var(--color-main);
                font-weight: var(--font-weight-lg);
                font-size: 12px;
                padding: 4px;
                border-radius: 6px;
                width: max-content;
                height: max-content;
            }

            &:last-child{
                width: 100px;
                display: flex;
                padding-top: 0;
                align-items: flex-end;
            }

        }

    }


    @keyframes blinkBorder {
    0% {
      border-color: transparent;
    }
    25% {
      border-color: var(--color-main);
    }
    50% {
      border-color: transparent;
    }
    75% {
      border-color: var(--color-main);
    }
    100% {
      border-color: transparent;
    }
  }

  .dots{
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${compactShipmentCardStyles}
`

const ItemContainer = ({item: sourceItem, activeItemId, setActiveItemId, forwardRef, handleClick}) => {
    const item = normalizeShipmentListItem(sourceItem)
    const { firstRoutePoint, lastRoutePoint } = getShipmentRouteBounds(item.routePoints)
    const [isActionsOpen, setIsActionsOpen] = useState(false)

    const titles = ["Sürücü ve Araç", "Yükleme", "Boşaltma", "Yük", "Diğer Bilgiler", , ""]    

    const {loadItemSelect} = useSelector(state => state.loadList)

    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))

    const dispatch = useDispatch()
    // const {userData} = useSelector((state)=>state.user)

    useEffect(() => {
        if(activeItemId === item.id){
            handleClick(item.id)
        }
    },[activeItemId])

    const showUserRateModal = (item) => {
        dispatch(setSelectUserData(item))

        if(item?.truckerUserRate?.$values[0]?.isApproved === 0 || item?.truckerUserRate?.$values[0]?.isApproved === 1 || item?.truckerUserRate?.$values[0]?.isApproved === 2){
            dispatch(showNestedModal("surucuDegerlendirmeBilgi"))
        }
        else{
            dispatch(showNestedModal("surucuProfilDegerlendir"))
        }
    }

    const handleBelgeDataClick = () => {

        const list = item.routePoints.$values.map((item) => {
            return {
                routeType: item.loadOrUnload,
                stateOfRoutePoint: item.stateOfRoutePoint,
                documentOfRoutePoint: item.documentOfRoutePoint,
                order: item.order,
                comment: item.description,
                location: item.location

            }
        }).filter(item =>  item.stateOfRoutePoint === 2)


        dispatch(getBelgeData(list))
    
        dispatch(showModal("shipmentIrsaliye"))
    }


  return (
    <Container ref={forwardRef} id={item.id} onClick={() => {setIsActionsOpen(false); window.getSelection().toString().length < 1 && setActiveItemId(item.id); item.waitinLoad.notificationType === 6 && dispatch(setTopPagesItemNotificationClicked({type: "tamamlanan", id: item.id}))}} border={item.waitinLoadId === loadItemSelect} isNotificationed={item.waitinLoad.notificationType === 6}>
    
        <div className="titles-container">
            {
                titles.map((item) => (
                    <div className="title-item">{item}</div>
                ))
            }
        </div>
        
         <div  className="content-container" >
            <CopyableShipmentValue className="absolute-id" label="ID" value={item.id} />

            <div className="content-column">
                               <div onClick={(e) => { e.stopPropagation(); dispatch(showNestedModal("surucuProfil")); dispatch(setSelectUserData(item?.driverPhoneNumber)) }} className="content-item driver">{item?.driverName}</div>
                               <div className="content-item">{item?.driverPhoneNumber}</div>
                                <div className="content-item">{item.truckPlateNumber} - {item.truckType}</div>
                               <div className="content-item">{item.trailerPlateNumber} - {item.trailerType} </div>
                           </div>
           
                           <div className="content-column">
                               <div className="content-item">{formatShipmentDate(firstRoutePoint.loadDate, value => moment(value).format("DD.MM.YYYY"))}</div>
                               <div className="content-item">{firstRoutePoint.loadTime} {firstRoutePoint.lateLoadTime}</div>
                               <div className="content-item">{firstRoutePoint.location}</div>
                               <div className="content-item">{firstRoutePoint.displayName}</div>
                           </div>
           
                           <div className="content-column">
                           <div className="content-item">{formatShipmentDate(lastRoutePoint.loadDate, value => moment(value).format("DD.MM.YYYY"))}</div>
                               <div className="content-item">{lastRoutePoint.loadTime} {lastRoutePoint.lateLoadTime}</div>
                               <div className="content-item">{lastRoutePoint.location}</div>
                               <div className="content-item">{lastRoutePoint.displayName}</div>
                           </div>
           
                           <div className="content-column">
                               <div className="content-item">{item.isParsiyel ? "LTL(Parsiyel)" : "FTL(Komple Araç)"}</div>
                               {
                                       item.loadUnit === "BASAR TONAJ" ? 
                                       <div className="content-item">Basar Tonaj {((item.itemBulk > 0) &&` - ${item.itemBulk}`)}</div>
                                       :
                                       <div className="content-item">{item.loadUnit === "BASAR TONAJ" ? "Basar Tonaj": `${item.loadQuantity} ${item.loadUnit}`}</div>
                                   }
                               <div className="content-item">{item.loadType}</div>
                           </div>
           
                           <div className="content-column">
                               <CopyableShipmentValue className="copy-field" label="Konteyner No" value={item.containerNumber} />
                               <CopyableShipmentValue className="copy-field" label="Mühür No" value={item.sealNumber} />
                               <CopyableShipmentValue className="copy-field" label="Firma Sevk. No" value={item.companyLoadNumber} />
                               <div className="content-item">Tamamlanma Saati: {formatShipmentDate(lastRoutePoint.routePointEndDate, value => moment(value).format("DD.MM.YYYY HH:mm"))}</div>
                           </div>

            <div className="content-column action-menu-column">
                <button
                    type="button"
                    className="more-button"
                    aria-label="Sefer işlemlerini göster"
                    aria-expanded={isActionsOpen}
                    onClick={(e) => {e.stopPropagation(); setIsActionsOpen((open) => !open)}}
                >
                    <MdOutlineMoreHoriz className="more-icon"/>
                </button>
                {isActionsOpen && (
                    <div className="actions-popover" onClick={(e) => e.stopPropagation()}>
                        <div className="content-item btn-outlined" onClick={(e)=> {e.stopPropagation(); setIsActionsOpen(false); handleBelgeDataClick(item)}}>Belgeler</div>
                        {(item?.truckerUserRate?.$values[0]?.isApproved === 0) && <div onClick={(e)=> {e.stopPropagation(); setIsActionsOpen(false); showUserRateModal(item)}} className="comment btn-outlined">Yorum Onay Bekliyor</div> }
                        {item?.truckerUserRate?.$values[0]?.isApproved === 1 && <div onClick={(e)=> {e.stopPropagation(); setIsActionsOpen(false); showUserRateModal(item)}} className="comment btn-outlined">Yorum Yayınlandı</div> }
                        {item?.truckerUserRate?.$values[0]?.isApproved === 2 && <div onClick={(e)=> {e.stopPropagation(); setIsActionsOpen(false); showUserRateModal(item)}} className="comment btn-outlined">Yorum Reddedildi</div> }
                        {item?.truckerUserRate?.$values[0]?.isApproved !== 0 && item?.truckerUserRate?.$values[0]?.isApproved !== 1 && item?.truckerUserRate?.$values[0]?.isApproved !== 2 && <div onClick={(e)=> {e.stopPropagation(); setIsActionsOpen(false); showUserRateModal(item)}} className="comment btn-outlined">Taşıyıcıyı Değerlendir</div> }
                    </div>
                )}
            </div>
        </div>
      
    </Container>
  )
}

export default ItemContainer
